export const COUPLE_LAYOUT_TYPE = {
  GRID3: 'grid3',
  GRID4: 'grid4',
  FULL: 'full',
  GRID3HIDDEN: 'grid3-hidden',
  PHOTOCARD: 'photocard',
} as const;

export type COUPLE_LAYOUT_TYPE_KEY = keyof typeof COUPLE_LAYOUT_TYPE;

export type COUPLE_LAYOUT_TYPE_VALUE =
  typeof COUPLE_LAYOUT_TYPE[COUPLE_LAYOUT_TYPE_KEY];

export const COUPLE_LAYOUT_TYPE_MAP = {
  [COUPLE_LAYOUT_TYPE.GRID3]: '3단형',
  [COUPLE_LAYOUT_TYPE.GRID3HIDDEN]: '3단 숨김형',
  [COUPLE_LAYOUT_TYPE.GRID4]: '4단형',
  [COUPLE_LAYOUT_TYPE.FULL]: '풀페이지형',
  [COUPLE_LAYOUT_TYPE.PHOTOCARD]: '포토카드 연동형',
};

export const coupleLayoutTypeList = Object.keys(COUPLE_LAYOUT_TYPE_MAP).map(
  (key) => {
    return {
      key: key,
      value: COUPLE_LAYOUT_TYPE_MAP[key],
    };
  },
);
